import { render, staticRenderFns } from "./table-employer-tags.vue?vue&type=template&id=57f5e63f"
import script from "./table-employer-tags.vue?vue&type=script&lang=js"
export * from "./table-employer-tags.vue?vue&type=script&lang=js"
import style0 from "./table-employer-tags.vue?vue&type=style&index=0&id=57f5e63f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports